import React from "react";
import classnames from 'classnames';
import Fall from "../animations/Fall";
import Llama from "../Llama";
import useTimeout from '../../hooks/useTimeout';

import * as s from './FallingLlama.module.css';

const Falling = ({type, onDone, style, ...props}) => {
    const rotation = React.useMemo(()=>Math.round((Math.random()-0.5)*360), []);
    useTimeout(onDone, 1000);
    return (
        <div className={s['root']} style={style}>
        <Fall duration="1s" to={{x:0, y:'100px', z: `${rotation}deg`}}>
            <Llama type={type} className={s['gray']} {...props}/>
        </Fall>
        </div>
    );
};

export default Falling;
